import { Box, Fade, IconButton, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ExploreHighSchool } from './types'
import { Link } from 'react-router-dom'
import { Tooltip } from '@scoir/tooltips'
import { faCalendar } from '@fortawesome/pro-regular-svg-icons'
import { encodeSelectedSchools } from '../encode-availability-link'

interface ExploreToolbarProps {
  selectedSchools: string[]
  schoolData?: ExploreHighSchool[]
}

function createSelectedSchoolsQueryParam(ids: string[], schools?: ExploreHighSchool[]): string {
  if (!schools) return ''
  const selectedSchools = schools.filter((school) => ids.includes(school.id))
  const schoolList = selectedSchools.map(({ id, name }) => ({ id, name }))
  const earliestVisitDate = selectedSchools
    .map((school) => school.nextVisitDate)
    .filter(Boolean)
    .sort()[0]

  return encodeSelectedSchools(schoolList, earliestVisitDate)
}

const ExploreToolbar = ({ selectedSchools, schoolData }: ExploreToolbarProps) => {
  const hasSelection = selectedSchools.length > 0

  return (
    <>
      <Box
        data-testid="control-box"
        display="flex"
        flexWrap="nowrap"
        alignItems="center"
        justifyContent="space-between"
        flexGrow="1"
        overflow="auto"
      >
        <Box
          flexGrow="1"
          display="flex"
          flexWrap="nowrap"
          alignItems="center"
          gridGap={2}
        >
          <Fade
            in={hasSelection}
            onExited={() => {
              selectedSchools.length = 0
            }}
            timeout={50}
          >
            <Box
              display={hasSelection ? 'flex' : 'none'}
              justifyContent="space-between"
              flexWrap="wrap"
            >
              <Box
                flexGrow={1}
                display="flex"
                whiteSpace="nowrap"
                alignItems="center"
                position="relative"
                style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
              >
                <Tooltip title="View Vist Availablity">
                  <IconButton
                    style={{ padding: '8px 8px' }}
                    color="primary"
                    size="small"
                    to={`${import.meta.env.BASE_URL}/recruit/visits/view/week?${createSelectedSchoolsQueryParam(
                      selectedSchools,
                      schoolData,
                    )}`}
                    disabled={selectedSchools.length === 0}
                    component={Link}
                  >
                    <FontAwesomeIcon icon={faCalendar} />
                  </IconButton>
                </Tooltip>
                <Box mx={1}>
                  <Typography variant="body1">{selectedSchools.length} Selected</Typography>
                </Box>
                {/* Add new actions here */}
              </Box>
            </Box>
          </Fade>
        </Box>
      </Box>
    </>
  )
}

export default ExploreToolbar
